<template>
  <van-pull-refresh
    class="all_page"
    v-model="isLoading"
    success-text="刷新成功"
    @refresh="onRefresh"
    v-swipeup="(e) => vueTouch('上滑', e)"
  >
    <div class="commonBg"></div>
    <div class="all">
      <!-- 首页轮播 -->
      <!-- <div class="lbwrap">
        <van-swipe
          class="my-swipe all_lb"
          :autoplay="lbwrapSwipeAutoplay"
          ref="lbwrapSwipe"
        >
          <van-swipe-item
            v-for="item in allData.banners"
            :key="item.id"
            @click="detailClick(item.id)"
          >
            <img :src="item.thumbnail" alt="" />
            <div class="con">
              <p>{{ item.title }}</p>
              <span>{{ item.memberNickName }} · {{ item.createTime }}</span>
            </div>
            <div class="bot"></div>
          </van-swipe-item>
        </van-swipe>
        <div
          class="swiper-prev"
          @click="swipePrev"
          v-if="!$store.state.isMobile"
        ></div>
        <div
          class="swiper-next"
          @click="swipeNext"
          v-if="!$store.state.isMobile"
        ></div>
      </div> -->
      <!-- 第七史诗签到 -->
      <!-- <div
        class="sign_box"
        v-if="$store.state.gameType == '3' && $store.state.loginStatus == 1"
      >
        <div
          :class="`item ${$parent.signToday == 0 ? '' : 'sign_ed'}`"
          @click="signTo"
        >
          <i class="sign_point" v-if="$parent.signToday == 0"></i>
          <i class="sign_icon2"></i>
          <span>{{ $parent.signToday == 0 ? '每日签到' : '今日已签' }}</span>
        </div>
        <div class="item" @click="goExchangeCenter">
          <i class="task_icon"></i>
          <span>兑换中心</span>
        </div>
      </div> -->
      <!-- 官方动态 -->
      <div class="offical_trends" v-if="allData.tops.length > 0">
        <h2>
          <span></span>
          官方资讯
        </h2>
        <ul>
          <li
            class="clear"
            v-for="item in allData.tops"
            :key="item.id"
            @click="detailClick(item.id)"
          >
            <span>{{ item.topicType }}</span>
            <p>{{ item.title }}</p>
          </li>
          <!-- <li class="clear">
            <span>资讯</span>
            <p>【龙之国物语】</p>
          </li> -->
        </ul>
      </div>
      <!-- 用于检测距离的盒子 -->
      <div class="offical_trends offical_trends_1" v-else></div>
      <!-- 热门话题 -->
      <!-- <a name="positioning"></a>
      <div class="hot_topic" v-show="allData.hotSubList.length > 0">
        <h2>
          <span></span>
          热门话题
        </h2>
        <ul class="topic_list">
          <li
            v-for="item in allData.hotSubList"
            :key="item.id"
            @click="hotClick(item)"
          >
            {{ item.subjectName }}
          </li>
        </ul>
      </div> -->
      <!-- 筛选条件 -->
      <div class="conditions clear">
        <p>筛选条件</p>
        <div class="conditons_right" @click="show = true">{{ sortName }}</div>
        <van-action-sheet
          v-model="show"
          :actions="actions"
          cancel-text="取消"
          close-on-click-action
          @cancel="onCancel"
          @select="onSelect($event)"
          @open="open"
          @close="close"
        />
      </div>
      <!-- 已發布帖子 -->
      <van-list
        v-model="listInit.loading"
        :finished="listInit.finished"
        finished-text="没有更多了"
        :immediate-check="false"
        @load="onLoad"
      >
        <card
          v-for="item in allData.topicsList"
          :key="item.id"
          :cardData="item"
          @removeCardCommon="removeCardCommon"
        ></card>
      </van-list>
    </div>
    <div class="task_tipbox" v-if="tipFlage">
      <sign @tipChange="tipChange" :tipItem="tipItem"></sign>
    </div>
  </van-pull-refresh>
</template>

<script>
import Vue from 'vue';
import get from '@/api/get';
import http from '@/api/get.js';
import card from '../../card';
import { Toast, Dialog } from 'vant';
import * as _code from '../../../utils/code';
import { mapState } from 'vuex';
import sign from '../../../components/task/tip/sign.vue';
export default {
  name: 'all',
  components: { card, sign },
  data() {
    return {
      name: 'all',
      images: ['@/assets/img/homePage/lb.jpg', '@/assets/img/homePage/lb.jpg'],
      show: false,
      actions: [{ name: '最新回复' }, { name: '最新發布' }, { name: '热门' }],
      sortType: 0,
      sortName: '最新回复',
      listInit: {
        loading: false,
        finished: false,
        sortType: 0,
        pageNo: 1,
        pageSize: 10
      },
      isLoading: false,
      tipFlage: false,
      tipItem: {},
      lbwrapSwipeAutoplay: 3000
    };
  },
  computed: {
    ...mapState({
      token: 'token'
    })
  },
  watch: {
    token(ne, ol) {
      this.init();
    }
  },
  props: ['allData'],
  async mounted() {
    if (this.$store.state.token == '') {
      const promise = new Promise((resolve) => {
        this.resolveHander = resolve;
      });
      await promise;
    }
    // this.init();
    this.listInit.pageNo = 1;
  },
  methods: {
    swipePrev() {
      this.$refs.lbwrapSwipe.prev();
      this.lbwrapSwipeAutoplay = 0;
      setTimeout(() => {
        this.lbwrapSwipeAutoplay = 3000;
      });
    },
    swipeNext() {
      this.$refs.lbwrapSwipe.next();
      this.lbwrapSwipeAutoplay = 0;
      setTimeout(() => {
        this.lbwrapSwipeAutoplay = 3000;
      });
    },
    tipChange() {
      this.tipFlage = !this.tipFlage;
    },
    signTo() {
      if (this.$parent.signToday == 0) {
        http.sign().then((res) => {
          if (res.data.code == 0) {
            this.tipItem = res.data.data;
            this.tipChange();
            this.$parent.signToday = 1;
          } else {
            this.errorMessage(res.data);
          }
        });
      }
    },
    goExchangeCenter() {
      this.$router.push({
        path: '/exchangeCenter',
        query: {
          type: 'needLoad'
        }
      });
    },
    //错误提示
    errorMessage(data) {
      let code = data.code;
      let voteErr = _code.code.vote;
      let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
      if (code == 2105) {
        //当前未绑定游戏信息，请前往游戏内社区进行签到
        Dialog({
          title: '当前未绑定游戏信息',
          message:
            '提供绑定方式如下\n方式一：用当前登录手机号注册游戏官方服。\n方式二：若已有游戏官方服三方账号，可在用户中心绑定当前登录手机号，但官方服三方账号下社区将覆盖当前登录社区账号。',
          confirmButtonColor: '#1474e0'
        });
      } else {
        Toast(msg);
      }
    },
    init() {
      this.listInit.pageNo = 1;
      this.listInit.refresh = true;
      this.$emit('tabClick', 1, '发现', this.listInit);
    },
    onCancel() {
      if (this.$store.state.system == 'iphone') {
        window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=0';
      }
      Toast('取消');
    },
    open() {
      if (this.$store.state.system == 'iphone') {
        window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=1';
      }
    },
    close() {
      if (this.$store.state.system == 'iphone') {
        window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=0';
      }
    },
    onSelect(item) {
      if (item.name == '最新回复')
        (this.sortType = 0), (this.sortName = item.name);
      if (item.name == '热门') (this.sortType = 2), (this.sortName = item.name);
      if (item.name == '最新發布')
        (this.sortType = 4), (this.sortName = item.name);
      this.listInit.sortType = this.sortType;
      this.init();
    },
    detailClick(id) {
      this.$store.state.anchorFlag = false;
      this.$router.push({
        path: '../topicPage/?topicId=' + id + '&isGame=true'
      });
    },
    hotClick(item) {
      this.$router.push({
        path: 'subjectPage',
        query: {
          id: item.id,
          subjectName: item.subjectName,
          subjectType: item.subjectType,
          topicCommentNum: item.topicCommentNum,
          topicViewNum: item.topicViewNum
        }
      });
    },
    // 下拉加载
    onLoad() {
      let _this = this;
      this.listInit.refresh = false;
      this.listInit.sortType = this.sortType;
      this.listInit.pageNo++;
      setTimeout(() => {
        this.$emit('tabClick', 1, '发现', this.listInit, function (newList) {
          // 加载状态结束
          _this.listInit.loading = false;
          // 数据全部加载完成
          if (newList.length < 10) {
            _this.listInit.finished = true;
            _this.listInit.pageNo--;
          }
        });
      }, 1000);
    },
    vueTouch(text, e) {
      this.listInit.finished = false;
      this.listInit.loading = true;
      setTimeout(() => {
        this.onLoad();
      }, 1000);
    },
    // 下拉刷新
    onRefresh() {
      var _this = this;
      _this.listInit.pageNo = 1;
      setTimeout(() => {
        this.isLoading = false;
        this.$emit('init');
        this.$emit('tabClick', 1, '发现', this.listInit, '', true);
        // Toast("刷新成功");
      }, 1000);
    },
    // card_common删除帖子
    removeCardCommon() {
      let _this = this;
      _this.$emit('tabClick', 1, '发现', this.listInit, '', true);
    },
    gopositioning() {
      location.href = '#positioning';
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>
